import { FormDropdown, FormDropdownProps } from '@vestwell-frontend/ui';

import React, { useMemo } from 'react';

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

function getMonthName(monthNumber: number): string {
  return monthNames[monthNumber - 1];
}

type MonthFormDropdownProps = Omit<FormDropdownProps, 'options'> & {
  options?: FormDropdownProps['options'];
};

const MonthFormDropdown: React.FC<MonthFormDropdownProps> = props => {
  const monthOptions = useMemo(
    () =>
      Array.from({ length: 12 }, (_, i) => ({
        label: getMonthName(i + 1),
        value: `${i + 1}`
      })),
    []
  );

  return <FormDropdown {...props} options={monthOptions} />;
};

export default MonthFormDropdown;
